export * from './allocation-view-couple-action.state';
export * from './allocation-view-couple-action.facade';
